import { DestroyRef, Directive, inject, input, Input, InputSignal, OnInit } from '@angular/core';
import { ProvideElementsDirective } from '../element-handling';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { first, firstValueFrom } from 'rxjs';
import { CustomTrackingService } from './services/custom-tracking.service';
import { PageTrackingEvent } from '@union-investment-b2b-portal/tracking-service/build/release/types/_external/ui-frontend/packages/libs/tracking/src/events';

@Directive({
  selector: '[wctFundsportraitTracking]',
  standalone: true
})
export class FundsportraitTrackingDirective implements OnInit {
  private readonly elements = inject(ProvideElementsDirective);
  private readonly destroyRef = inject(DestroyRef);
  private readonly customTrackingService = inject(CustomTrackingService);

  public readonly anteilsscheinname: InputSignal<string> = input.required();
  public readonly isin: InputSignal<string> = input.required();

  ngOnInit(): void {
    this.elements.elementsLoaded.pipe(takeUntilDestroyed(this.destroyRef), first()).subscribe(async () => {
      const antsname = await firstValueFrom(this.elements.elementContext.getElement(this.anteilsscheinname()));
      const isin = await firstValueFrom(this.elements.elementContext.getElement(this.isin()));

      const trackEventConfig: PageTrackingEvent = {
          eventInfo: {
            eventName: 'Load Page',
            eventType: 'Page',
          },
          attributes: {
            pageContentId: `IK.Fondsportrait.${antsname.renderable.content}`,
            pageName: antsname.renderable.content,
            pageUrl: window.location.href,
            pageInstanceName: 'ik-online',
            customSessionParameter: {},
            customECommerceParameter: {
              2: 'Fondsportrait',
              47: isin.renderable.content,
              48: 'wct-fondsportrait',
              49: '2',
              50: 'rpt',
            },
          },
          category: { contentGroups: [] },
        };

      this.customTrackingService.runTracking(trackEventConfig);
    })
  }

}
